module.exports = __webpack_public_path__ + "assets/cerapro-regular-webfont.0553e330.woff2";